/* ==========================================================================
   SEARCH PANEL — popular search terms, and the two product cards that follow
   whichever term the pointer is on. Companion to `sections/stl-search-panel
   .liquid` and `sections/stl-predictive-search.liquid`.

   Reference is minkpink.com, which runs Searchspring. Everything here is
   Shopify's own predictive search instead:

     /search/suggest?q=<term>&section_id=stl-predictive-search
                    &resources[type]=product&resources[limit]=2

   `section_id` renders OUR liquid, so the ranking is Shopify's (and is tunable
   in Search & Discovery with synonyms, boosts and pins) while the markup is
   ours. The one thing that is not native is the LIST of terms — Shopify has no
   storefront API for popular searches — so those come from the section's blocks.

   THE PANEL MARKUP IS MOVED, NOT REBUILT. `snippets/search-modal.liquid` is a
   snippet and cannot host blocks, so the section renders at the foot of <body>
   and this file relocates it. Same pattern as the mini cart and the PDP badges.
   ========================================================================== */
(function () {
  'use strict';

  var SECTION = 'stl-predictive-search';
  var LIMIT = 2;

  /* Term -> rendered HTML. The list is short and curated, so after one pass
     round the terms every hover is instant and costs no request. */
  var cache = {};
  var inFlight = null;
  var current = null;

  function suggestUrl(term) {
    var base =
      (window.routes && window.routes.predictive_search_url) || '/search/suggest';

    /* `resources[limit]` IS A SHARED BUDGET ACROSS TYPES. Asking for
       `product,query` with a limit of 2 returns ONE product and ONE query,
       which reads as the limit being ignored. Products are asked for alone.
       The brackets are percent-encoded so the query string survives every
       proxy between here and Shopify. */
    return (
      base +
      '?q=' + encodeURIComponent(term) +
      '&section_id=' + SECTION +
      '&resources%5Btype%5D=product' +
      '&resources%5Blimit%5D=' + LIMIT
    );
  }

  /* --- placing the panel -------------------------------------------------- */

  function place() {
    var src = document.querySelector('[data-stl-search-panel]');
    if (!src) return;

    var main = document.querySelector('search-modal .search__main');
    if (!main) return;

    /* GUARD ON THE MARKUP, NOT ON A FLAG — a `data-` flag set on a container
       outlives an inner-HTML re-render and then reports "already built" over an
       empty panel. That trap has already cost this build the sort control once. */
    if (main.querySelector('.stl-search-panel')) return;

    var clone = src.cloneNode(true);
    clone.removeAttribute('hidden');
    clone.removeAttribute('data-stl-search-panel');
    main.appendChild(clone);

    placeTitle(src.getAttribute('data-stl-panel-title'));
    wire(clone);
    reset(clone);
  }

  /* Madrid's panel header holds nothing but the close button; the design puts a
     title beside it, on one line. Inserted rather than written into the snippet
     so the wording stays an editor setting and no core file is touched. */
  function placeTitle(text) {
    if (!text) return;
    var wrap = document.querySelector('search-modal .search__header-wrapper');
    if (!wrap || wrap.querySelector('.stl-search-title')) return;

    var el = document.createElement('p');
    el.className = 'stl-search-title';
    el.textContent = text;
    wrap.insertBefore(el, wrap.firstChild);
  }

  /* --- choosing a term ---------------------------------------------------- */

  function render(panel, html) {
    var box = panel.querySelector('[data-stl-suggest]');
    if (!box) return;
    box.innerHTML = html;
    box.setAttribute('aria-busy', 'false');
  }

  function select(panel, link) {
    if (!link) return;
    var term = link.getAttribute('data-stl-term');
    if (!term || term === current) return;
    current = term;

    var links = panel.querySelectorAll('[data-stl-term]');
    for (var i = 0; i < links.length; i++) {
      links[i].classList.toggle('is-active', links[i] === link);
    }

    if (cache[term] !== undefined) {
      render(panel, cache[term]);
      return;
    }

    /* Moving the pointer across the row starts a request per term. Without the
       abort the responses can land out of order and the panel settles on a term
       the pointer has already left. */
    if (inFlight) inFlight.abort();
    var ctrl = new AbortController();
    inFlight = ctrl;

    var box = panel.querySelector('[data-stl-suggest]');
    if (box) box.setAttribute('aria-busy', 'true');

    fetch(suggestUrl(term), { signal: ctrl.signal })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        cache[term] = html;
        if (current === term) render(panel, html);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        /* A failed request must not leave the previous term's cards standing
           under the new term's label — that misattributes them. */
        if (current === term) render(panel, '');
      });
  }

  function wire(panel) {
    var links = panel.querySelectorAll('[data-stl-term]');
    for (var i = 0; i < links.length; i++) {
      (function (link) {
        /* `mouseenter` rather than `mouseover`: it does not re-fire as the
           pointer crosses the anchor's own text node. `focus` gives keyboard
           users the same behaviour. On touch there is no hover at all and the
           anchor simply navigates, which is why each term is a real
           `/search?q=…` URL rather than a button. */
        link.addEventListener('mouseenter', function () {
          select(panel, link);
        });
        link.addEventListener('focus', function () {
          select(panel, link);
        });
      })(links[i]);
    }

    /* While there is a query the native predictive results own the panel, so
       the resting content steps aside. Keyed on the field's own value rather
       than on any of Madrid's internal classes. */
    var input = document.querySelector('search-modal .search__input');
    if (input) {
      var sync = function () {
        panel.classList.toggle('stl-search-panel--typing', input.value.trim().length > 0);
      };
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      sync();
    }
  }

  /* The first term is preselected so the panel is never empty on open — which
     is also what the reference does. */
  function reset(panel) {
    var first = panel.querySelector('[data-stl-term]');
    if (!first) return;
    current = null;
    select(panel, first);
  }

  /* --- the typed state ---------------------------------------------------- */

  /* Madrid's own predictive results carry a hardcoded "Product Suggestions"
     fallback. Copy the section setting over it so the typed and resting states
     always read the same word — the two headings are rendered by two different
     sections and would otherwise drift the moment the setting is edited. */
  function syncHeading() {
    var src = document.querySelector(
      '[data-stl-search-panel] .stl-search-panel__suggestions .stl-search-panel__heading'
    );
    if (!src) return;
    var live = document.querySelectorAll('[data-stl-suggest-heading]');
    for (var i = 0; i < live.length; i++) {
      if (live[i].textContent !== src.textContent) live[i].textContent = src.textContent;
    }
  }

  /* --- the search RESULTS page has no modal opener ------------------------- */

  /* MADRID DELIBERATELY DOES NOT RENDER ONE THERE. The three header snippets
     branch on `{% if request.page_type != 'search' %}`: everywhere else the
     control is a `<div id="search-icon-open" role="button">` that
     `SearchModal.setHeaderCartIconAccessibility()` binds, and on /search it is a
     plain `<a href="/search">`. That is reasonable in stock Madrid, because the
     search page carries its own form — but this build hides that form once there
     are results, so clicking search on a results page reloaded /search and
     nothing else. Serena reported exactly that.

     Upgraded here rather than by editing the three header snippets: one place,
     no upgrade debt, and with the script absent it degrades to Madrid's link,
     which still reaches a working page.

     `SearchModal.open()` is a public method on the custom element, so this is the
     same entry point the id-bound control uses — not a reimplementation. The flag
     guards a LISTENER rather than markup, which is the one case where a `data-`
     flag is the right guard: the header is never re-rendered, and re-binding
     would double every click. */
  function wireResultsPageOpener() {
    var modal = document.querySelector('search-modal');
    var link = document.querySelector('a.header__icon--search');
    if (!modal || !link || typeof modal.open !== 'function') return false;
    if (link.dataset.stlOpener) return true;

    link.dataset.stlOpener = '1';
    link.setAttribute('role', 'button');
    link.setAttribute('aria-haspopup', 'dialog');

    link.addEventListener('click', function (e) {
      e.preventDefault();
      modal.open(link);
    });
    link.addEventListener('keydown', function (e) {
      if (e.code && e.code.toUpperCase() === 'SPACE') {
        e.preventDefault();
        modal.open(link);
      }
    });
    return true;
  }

  /* --- lifecycle ---------------------------------------------------------- */

  function boot() {
    place();

    /* `global.js` defines <search-modal> and both scripts are deferred, so it has
       normally upgraded by now — but the retry costs nothing and covers the case
       where it has not. */
    if (!wireResultsPageOpener()) setTimeout(wireResultsPageOpener, 500);

    var modal = document.querySelector('search-modal');
    if (!modal) return;

    /* The typed results are replaced wholesale on every keystroke, so the heading
       has to be re-synced each time rather than once. */
    var results = modal.querySelector('[data-predictive-search]');
    if (results) {
      new MutationObserver(syncHeading).observe(results, { childList: true, subtree: true });
    }

    /* Re-preselect each time the panel opens, so a visitor who searched, closed
       and reopened does not meet the last term they happened to hover. Madrid
       marks the open state with `active` on the custom element. */
    var wasOpen = modal.classList.contains('active');
    new MutationObserver(function () {
      var open = modal.classList.contains('active');
      if (open && !wasOpen) {
        var panel = modal.querySelector('.stl-search-panel');
        if (panel) reset(panel);
      }
      wasOpen = open;
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
